import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { getAttribution } from "@/lib/attribution";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FileDown, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function IfaChecklistDownload() {
  const [form, setForm] = useState({ name: "", email: "", org_name: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const res = await api.post("/downloads/ifa-checklist", { ...form, attribution: getAttribution() }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = "IFA-inspection-readiness-checklist.pdf"; a.click(); URL.revokeObjectURL(url);
      setDone(true);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Could not prepare the download"); }
    finally { setBusy(false); }
  };

  return (
    <section className="rounded-3xl border border-amber-500/30 bg-amber-500/5 p-6 sm:p-8" data-testid="ifa-checklist-download">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-amber-700 mb-2">Free download</p>
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-3">IFA inspection-readiness checklist</h2>
          <p className="text-muted-foreground">A printable, 25-point checklist mapped to the Fostering Services Regulations 2011, the National Minimum Standards and the SCCIF — registration, panel &amp; ADM, carers, children's protection and governance. Tick, date and initial.</p>
        </div>
        {done ? (
          <div className="rounded-2xl bg-card border border-border p-6 text-sm flex gap-3" data-testid="ifa-checklist-done">
            <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" />
            <p>Your download has started. We've added you to the fostering compliance digest — every email has an unsubscribe link.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-2xl bg-card border border-border p-5 space-y-3" data-testid="ifa-checklist-form">
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" data-testid="ifa-checklist-name" />
            <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Work email" data-testid="ifa-checklist-email" />
            <Input value={form.org_name} onChange={(e) => setForm({ ...form, org_name: e.target.value })} placeholder="Agency name (optional)" data-testid="ifa-checklist-org" />
            <Button type="submit" className="w-full" disabled={busy} data-testid="ifa-checklist-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><FileDown className="w-4 h-4 mr-1.5" /> Email me the checklist</>}</Button>
            <p className="text-[11px] text-muted-foreground">By downloading you agree to receive the fostering compliance digest from Futuregen Innovations. Unsubscribe any time — see our <a href="/privacy#marketing" className="underline">privacy policy</a>.</p>
          </form>
        )}
      </div>
    </section>
  );
}
